import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./assets/css/main.css";

//Sweet alert
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

//Axios
import axios from "axios";

import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
Vue.use(Vuetify);

//Slide
import VueCarousel from "vue-carousel";
Vue.use(VueCarousel);

//Sidebar menu
import VueSidebarMenu from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";
Vue.use(VueSidebarMenu);

Vue.config.productionTip = false;

/* COMPONENTES */
import menuMain from "./components/web/menu.vue";
Vue.component("menu-main", menuMain);

import footer from "./components/web/footer.vue";
Vue.component("footer-main", footer);

import producto from "./components/producto.vue";
Vue.component("producto", producto);

import menuMobile from "./components/menu_mobile.vue";
Vue.component("menu-mobile", menuMobile);

import Lingallery from "lingallery";
Vue.component("lingallery", Lingallery);

/* COMPONENTES ADMIN */
import producto_admin from "./components/producto_admin.vue";
Vue.component("producto-admin", producto_admin);
import menu_admin from "./components/menu_admin.vue";
Vue.component("menu-admin", menu_admin);
import vuetify from "./plugins/vuetify";

/*
  Verificamos si el usuario está conectado
*/
if (localStorage.getItem("id") != null) {
  //El usuario está conectado
  const id = localStorage.getItem("id");

  axios
    .get(
      "https://vossmueblerias.com.mx/backend/api/auth/auth__controller.php?ot=getUserData&id=" +
        id
    )
    .then((response) => {
      store.dispatch("verificarUsuarioConectado", {
        usuario: response.data.user,
        nombre: response.data.nombre,
        id: response.data.id,
      });

      new Vue({
        router,
        store,
        Vuetify,
        vuetify,
        render: (h) => h(App),
      }).$mount("#app");
    })
    .catch(function(error) {
      console.log(error);
    });
} else {
  //EL usuario no está conectado
  store.dispatch("verificarUsuarioConectado", null);

  new Vue({
    router,
    store,
    Vuetify,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
}
